// extracted by mini-css-extract-plugin
module.exports = {"icon":"mEltpdvyjh0L-I9YMsmpe"};